export enum DocumentSourceDomain {
  VpaApply,
  VpaApplicationManagement,
  AdditionalVpa,
  SoldCampaigns,
  VpaPay
}
